export enum WidgetsHideConditionsSelector {
  SELECTED_ACCOUNT = 'selectedAccount',
  SELECTED_BENEFICIARY = 'selectedBeneficiary',
  SAVINGS_ACCOUNT_REQUESTS = 'savingsAccountRequests',
  VERIFICATION_LOTTIE_ANIMATION = 'verificationLottieAnimation',
}

//This map stores the handlebar keys that could be used in hide conditions
// we pass the key from the widget and the value is the list of possible handlebar keys
// Add new keys here as we provide the feature on other widgets
export const hideConditionsRepository = new Map<WidgetsHideConditionsSelector, string[]>([
  [
    WidgetsHideConditionsSelector.SELECTED_ACCOUNT,
    ['currency', 'country', 'accountCurrency', 'selectedAccountStatus', 'accountCountry', 'accountBalance'],
  ],
  [WidgetsHideConditionsSelector.SELECTED_BENEFICIARY, ['selectedBeneficiary', 'beneficiaryDetail']],
  [WidgetsHideConditionsSelector.SAVINGS_ACCOUNT_REQUESTS, ['savingsAccounts.totalAccountRequests']],
  [WidgetsHideConditionsSelector.VERIFICATION_LOTTIE_ANIMATION, ['profile.kycVerificationStatus']],
]);
